import { render, staticRenderFns } from "./CalendarViewTimelineViewEvent.vue?vue&type=template&id=2d23110e&scoped=true&"
import script from "./CalendarViewTimelineViewEvent.vue?vue&type=script&lang=ts&"
export * from "./CalendarViewTimelineViewEvent.vue?vue&type=script&lang=ts&"
import style0 from "./CalendarViewTimelineViewEvent.vue?vue&type=style&index=0&id=2d23110e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d23110e",
  null
  
)

export default component.exports